import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { translations, getTranslation } from '../i18n/translations';

export const useTranslation = () => {
  const { language } = useAuth();

  const t = useCallback((path, params = {}) => {
    let text = getTranslation(language, path);
    Object.entries(params).forEach(([key, value]) => {
      text = text.replace(new RegExp(`{{${key}}}`, 'g'), value);
    });
    return text;
  }, [language]);

  return { t, language, translations: translations[language] };
};
